import FileTemplate from "lib/hex/lib/resultsview/templates/FileTemplate";
import PropTypes from "prop-types";
import React from "react";
import { leftPad } from "lib/pad";
import formatId from "lib/formatId";

export default class Item extends React.Component {
    render() {
        const { renderUnsafe = false, type, ITid, } = this.props;
        let template;
        if (renderUnsafe && type !== "template") {
            template = <span dangerouslySetInnerHTML={{__html: this.getLabel()}} />;
        } else {
            template = this.getLabel();
        }
        return <td data-control-type="label" id={formatId(ITid, "selection-table-field")}>{template}</td>;
    }

    getLabel() {
        const { optionsKey, data, type, ItemTemplate, onDownloadClick, valueMap } = this.props;
        let value = data[optionsKey];
        if (valueMap && valueMap.hasOwnProperty(value)) {
            value = valueMap[value];
        }
        let display = "";
        if (value != null) {
            switch (type.replace(/ormissing$/, "")) {
                case "datetimerelative":
                case "datetimerange":
                case "datetime":
                    if (value.length >= 2) {
                        value = [].concat(value);
                        value[1] -= 1; // zero indexed month
                    }
                    display = moment(value).format("MM/DD/YYYY h:mm a");
                    break;
                case "daterelative":
                case "daterange":
                case "date":
                    if (value.length >= 2) {
                        value = [].concat(value);
                        value[1] -= 1; // zero indexed month
                    }
                    display = moment(value).format("MM/DD/YYYY");
                    break;
                case "time":
                    if (value.length < 2) {
                        display = "";
                    } else {
                        display = `${leftPad(value[0], 2, "0")}:${leftPad(value[1], 2, "0")}`;
                    }
                    break;
                case "tztimestamp":
                    display = moment(new Date(value)).format("MM/DD/YYYY h:mm a");
                    break;
                case "string":
                case "to-one":
                case "integer":
                    display = value.toString();
                    break;
                case "template":
                display = <FileTemplate onDownloadClick={onDownloadClick}
                                                    data={data}/>;
                    break;
                case "to-many":
                    if (value instanceof Array) {
                        display = value.join(", ");
                    } else {
                        display = value.toString();
                    }
                    break;
                default:
                    display = `UNKNOWN TYPE '${type}'`;
            }
        } else if (type === "template" && ItemTemplate != null) {
            display = <ItemTemplate onDownloadClick={onDownloadClick}
                                    data={data} />;
        }
        return display;
    }
}

Item.propTypes = {
    optionsKey: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    type: PropTypes.string,
    ItemTemplate: PropTypes.func,
    onDownloadClick: PropTypes.func,
    renderUnsafe: PropTypes.bool,
    ITid: PropTypes.string,
    valueMap: PropTypes.object, // used for translation
};



// WEBPACK FOOTER //
// ./app/lib/common/selectiontable/lib/body/Item.js